/** MUTATIONS */
import { gql } from '@apollo/client';

/** mutation to update project */
export const UPDATE_PROJECT = gql`
mutation updateProject($input: UpdateProjectInput) {
  updateProject(input: $input)
}
`;

/** mutation to copy project */
export const COPY_PROJECT = gql`
mutation copyProject($input: CopyProjectInput) {
  copyProject(input: $input)
}
`;

/** mutation to create project */
export const CREATE_PROJECT = gql`
mutation createProject($input: CreateProjectInput) {
  createProject(input: $input)
}
`;

/** mutation to delete reconciliation file info */
export const DELETE_RECON_FILE_INFO = gql`
mutation deleteReconFileInfo($input: DeleteFileInfoInput) {
  deleteReconFileInfo(input: $input)
}
`;

/** mutation to create file information */
export const CREATE_FILE_INFO = gql`
mutation createFileInfo($input: CreateFileInfoInput ) {
  createFileInfo(input: $input){
    uploadId
  }
}
`;

export const CREATE_FILE_INFO_AUTOMATED_RECON = gql`
mutation createFileInfoForAutomatedRecon($input: CreateFileInfoInput ) {
  createFileInfoForAutomatedRecon(input: $input){
    uploadId
  }
}
`;

/** mutation to create directory */
export const CREATE_DIRECTORY = gql`
mutation DQcreateDir($dirName: String,$parentDirId:Int) {
  DQcreateDir(dirName: $dirName,parentDirId:$parentDirId){
    dirId
    dirName
    parentDirId
  }
}
`;

/** mutation to rename directory or file */
export const RENAME_DIRECTORY_OR_FILE = gql`
mutation DQrenameFileDir($dirId: Int,$id:Int,$newName:String,$type:String) {
  DQrenameFileDir(dirId: $dirId,id:$id,newName:$newName,type:$type){
    success
  }
}
`;

/** mutation to delete directory or file */
export const DELETE_DIRECTORY_OR_FILE = gql`
mutation DQdeleteFileDir($dirId: Int,$deleteList:[FileFolderObjInput]) {
  DQdeleteFileDir(dirId: $dirId,deleteList:$deleteList){
    deleteStatus{
      id
      type
      success
    }
  }
}
`;

/** mutation to share directory or file */
export const SHARE_DIRECTORY_OR_FILE = gql`
mutation DQshareFileDir($dirId: Int,$sharedItems:[FileFolderObjInput],$sharedUserId:Int) {
  DQshareFileDir(dirId: $dirId,sharedItems:$sharedItems,sharedUserId:$sharedUserId){
    shareStatus{
      id
      type
      success
    }
  }
}
`;

/** mutation to move directory or file */
export const MOVE_DIRECTORY_OR_FILE = gql`
mutation DQmoveFileDir($dirId: Int,$movedItems:[FileFolderObjInput],$targetDirId:Int) {
  DQmoveFileDir(dirId: $dirId,movedItems:$movedItems,targetDirId:$targetDirId){
    moveStatus{
      id
      type
      success
    }
  }
}
`;
